import { urls } from '~/preloaded';
import { get } from '~/helpers/api';

import { sendErrorNotification } from '~/web2ClientAPI/base';
import { actionsClanBattles } from '~/Actions/ActionClanBattles';
import { fetchClan } from '~/Actions/ActionClanProfile';

import type { AppAsyncThunk } from '~/store';
import type { IClanBattle } from '~/types/declaration';
import type { Nullable, Nullish } from '~/types/generics';

export const checkClanBattlesThunk = (): AppAsyncThunk => async (dispatch, getState) => {
  const currentClanId = getState().currentAccount?.clanId;

  const executeRequest = async (leadingTeam?: Nullable<number>) => {
    const team = leadingTeam || 1;
    dispatch(actionsClanBattles.setSelectedTeamNumber(team));

    if (currentClanId) {
      try {
        const url = `${urls.ladderClanBattles}?team=${team}`;
        const response = await get<IClanBattle[]>(url);

        dispatch(actionsClanBattles.setClanBattles(response));
      } catch (error) {
        sendErrorNotification();
      } finally {
        dispatch(actionsClanBattles.setClanBattlesFetching(false));
      }
    }
  };

  let leadingTeamNumber: Nullish<number>;

  if (currentClanId) {
    dispatch(actionsClanBattles.setClanBattlesFetching(true));

    await dispatch(fetchClan(currentClanId, false));

    const wowsLadder = getState().clans.wowsLadder[currentClanId];
    if (wowsLadder) {
      leadingTeamNumber = wowsLadder.leading_team_number;
    }
  }

  await executeRequest(leadingTeamNumber);
};

export const getClanBattlesThunk = (): AppAsyncThunk => async (dispatch, getState) => {
  dispatch(actionsClanBattles.setClanBattlesFetching(true));

  try {
    const state = getState();
    const url = `${urls.ladderClanBattles}?team=${state.ReducerClanBattles.teamNumber}`;
    const response = await get<IClanBattle[]>(url);

    dispatch(actionsClanBattles.setClanBattles(response));
  } catch (error) {
    sendErrorNotification();
  } finally {
    dispatch(actionsClanBattles.setClanBattlesFetching(false));
  }
};
